import { xhrFetch } from "../utilities/xhrManager";
import Swiper from "swiper";
import { handleize } from "../utilities/Helpers/helpers";
import LaravelErrorResponse from "../utilities/Validation/laravelErrorResponse";
import { handleAriaExpandedClick } from "../utilities/Helpers/Accesibility/Expanded";
import Modal from "../utilities/Helpers/UI/Modal";
import * as Analytics from "../utilities/Analytics/Analytics";
LUC.jsStoreLocator = {
    alpine: true,
    zipCode: "",
    get isByDistance() {
        return this.stores.length ? this.stores[0].distance : false;
    },
    stores: [],
    meta: { zip: null },
    recentlyOpenedStores: [],
    storeDetail: null,
    errorMessages: null,
    directStoreQueryString: null,
    init() {
        this.errorMessages = new LaravelErrorResponse({});
        this.updateRecentlyOpenedDynamically();
        this.storeDirectStoreQueryString();
        this.watchHistoryState();
        this.fetchStores().then(() => {
            this.directToStoreOnQuerystringEnter();
        });
    },
    updateRecentlyOpenedDynamically: function () {
        this.$watch("stores", () => {
            this.recentlyOpenedStores = this.stores.filter((store) => store.recently_opened);
            this.$nextTick(() => this.newlySwiper());
        });
    },
    openDetailPage: function (store) {
        Analytics.trackEvent("store_locator_store_details_opened", {
            store_id: store.id,
            store_title: store.title,
            store_city: store.city,
        });
        this.storeDetail = store;
        history.pushState(JSON.stringify(store), "", `?store=${handleize(store.title)}`);
        window.scrollTo({ top: 0, behavior: "instant" });
        this.$nextTick(() => this.buildDetailSlider());
    },
    watchHistoryState: function () {
        history.replaceState(undefined, "", document.location.pathname);
        window.addEventListener("popstate", (evt) => {
            this.storeDetail = evt.state ? JSON.parse(evt.state) : null;
        });
    },
    fetchStores: async function () {
        this.errorMessages.clear();
        let url = this.buildAPIUrl();

        await xhrFetch(
            url,
            {},
            (data) => {
                this.stores = data.data;
                if (this.meta) {
                    this.meta = data.meta;
                    this.zipCode = data.meta?.zip ?? "";
                    if (this.zipCode) {
                        Analytics.trackEvent("store_locator_find_by_zipcode", { zip_code: this.zipCode });
                    }
                }
            },
            (error) => {
                console.error("Store Locator fetchStores error", error);
                this.errorMessages.setErrors(error.errors);
            }
        );
    },
    getLocation: function () {
        //TODO: refactor into global alpine helper after implementing Alpine further
        this.zipCode = "";
        const storePosition = (pos) => {
            Alpine.store("geoLocation", {
                lat: pos.coords.latitude,
                lng: pos.coords.longitude,
            });
            this.$nextTick(() => this.fetchStores());
        };

        navigator.geolocation.getCurrentPosition(storePosition, (pos) => console.error(pos));
    },
    openAppointmentModal: function (store_id) {
        let store_dict = document.querySelector("[data-sl-dict]")?.dataset.slDict;
        if (store_dict) {
            store_dict = JSON.parse(store_dict.replace(/'/g, '"'));
            let store_name = store_dict[store_id];
            if (store_name) {
                $('#select-3 option[value="In Store Appointment"]').prop("selected", true);
                $("#45211-select").prop("disabled", "");
                $('#45211-select option[value="' + store_name[0] + '"]').prop("selected", true);
                $("#hidden").val(store_name[1]);
                $(".globo-form-control.conditional-field").css({ display: "block" });

                Analytics.trackEvent("store_locator_appointment_modal_opened", {
                    store_id: store_id,
                    store_name: store_name,
                });
            }
        }
        const modal = Modal.getModalByName("contact-modal-container");
        modal.show();
    },
    unload: function () {},
    findStoreByHandle: function (handle) {
        return this.stores.find((store) => handleize(store.title) === handle);
    },
    directToStoreOnQuerystringEnter: function () {
        if (this.directStoreQueryString) {
            this.openDetailPage(this.findStoreByHandle(this.directStoreQueryString));
        }
    },
    newlySwiper: function () {
        let slider = document.querySelector("#recently-opened-stores");
        new Swiper(slider, {
            slidesPerView: 1.5,
            spaceBetween: 16,
            centeredSlides: false,
            loop: false,
            autoplay: false,
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                    centeredSlides: false,
                },
            },
        });

        this.newlySwiper = function () {}; //Swiper needs to be initialized only once
    },
    buildDetailSlider: function () {
        let slider = document.querySelector("#locator-details-slider");
        new Swiper(slider, {
            slidesPerView: 1.5,
            spaceBetween: 16,
            centeredSlides: false,
            loop: false,
            autoplay: false,
        });
    },
    toast: function (message) {
        return undefined;
    },
    buildAPIUrl: function () {
        const apiDomain =
            window.location.host === "lucchese-staging.myshopify.com"
                ? "https://ais-staging.lucchese.com"
                : "https://ais.lucchese.com";
        let url = `${apiDomain}/locations`;
        if (this.zipCode) {
            url += `?zipcode=${this.zipCode}`;
        } else if (this.$store.geoLocation?.lat && this.$store.geoLocation?.lng) {
            url += `?lat=${this.$store.geoLocation.lat}&lng=${this.$store.geoLocation.lng}`;
            this.$nextTick(() => Alpine.store("geoLocation", {})); // hardcoded quickfix, TODO: need to redesign the feature
        }
        return url;
    },
    includesNearbyStores: function () {
        return this.isByDistance && this.stores?.filter((store) => store.distance < 100).length > 0;
    },
    handleize: function (string) {
        return handleize(string);
    },
    storeDirectStoreQueryString() {
        this.directStoreQueryString = new URLSearchParams(window.location.search).get("store");
    },
    clearZipCode() {
        this.zipCode = "";
        this.fetchStores();
    },
    a11yExpandedClick(event) {
        handleAriaExpandedClick(event);
    },
};
